import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const accessToken = localStorage.getItem('access_token');
    if (!accessToken) {
      setUser(false);
      setLoading(false);
      return;
    }
    try {
      const { data } = await axios.get(`${API_URL}/api/auth/me`, {
        withCredentials: true,
        timeout: 10000,
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      setUser(data);
    } catch (error) {
      const isAuthError = error.response && error.response.status === 401;
      if (isAuthError) {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        setUser(false);
      } else {
        setUser(prev => prev || false);
      }
    } finally {
      setLoading(false);
    }
  };

  const persistTokens = (data) => {
    if (data?.access_token) localStorage.setItem('access_token', data.access_token);
    if (data?.refresh_token) localStorage.setItem('refresh_token', data.refresh_token);
  };

  const login = async (email, password) => {
    const { data } = await axios.post(
      `${API_URL}/api/auth/login`,
      { email, password },
      { withCredentials: true }
    );
    persistTokens(data);
    setUser(data);
    return data;
  };

  const register = async (name, email, password) => {
    const { data } = await axios.post(
      `${API_URL}/api/auth/register`,
      { name, email, password },
      { withCredentials: true }
    );
    persistTokens(data);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await axios.post(`${API_URL}/api/auth/logout`, {}, { withCredentials: true });
    } catch (e) {}
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
